module.exports = __webpack_public_path__ + "img/11.69dc1cd6.png";